import {IFeedbackData} from "../types/feedback";
import apiUtil from "@/util/apiUtil";

const feedbackAPI = {
    async submitFeedback(feedbackData: IFeedbackData): Promise<IFeedbackData> {
        return apiUtil.postData("/api/CoachAssistant/feedback", feedbackData);
    },

    async deleteFeedback(id: number): Promise<void> {
        return apiUtil.deleteData(`api/CoachAssistant/feedback/${id}`);
    }
};

export default feedbackAPI;
